import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { Recipient, StateResponse, UpdateBillingAddressRequestPayload } from 'api/api';

import { apiInstance, useGlobalState, useGlobalStateUpdate } from '~src/global-state';

import { complementAddress } from '~address-form/utils/format';

export type BillingAddressMutation = UseMutationResult<
  StateResponse | undefined,
  AxiosError<{ message?: string }>,
  Recipient | undefined
>;

export function useBillingAddressMutation() {
  const updateGlobalState = useGlobalStateUpdate();
  const globalState = useGlobalState();

  const mutationFn = async (billingAddress: Recipient | undefined) => {
    const userId = globalState.address_book?.user_id;

    const newBillingAddress = billingAddress
      ? {
          ...complementAddress(billingAddress, globalState.purchase_country),
          country: globalState.purchase_country,
        }
      : undefined;

    const payload: UpdateBillingAddressRequestPayload = {
      billing_address: newBillingAddress,
      user_id: userId,
    };

    const { data } = await apiInstance.v4.updateBillingAddressPost(
      globalState.checkout_session_id,
      payload
    );
    return data.state_response;
  };

  return useMutation<
    StateResponse | undefined,
    AxiosError<{ message?: string }>,
    Recipient | undefined
  >({
    mutationFn,
    mutationKey: ['billing-address'],
    onSuccess: state_response => {
      if (state_response === undefined) {
        return;
      }
      void updateGlobalState(state_response);
    },
  });
}
